const isMutableRefObject = (thing) => thing !== undefined;
// from https://www.davedrinks.coffee/how-do-i-use-two-react-refs/
export const mergeRefs = (...refs) => {
    const filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length)
        return null;
    if (filteredRefs.length === 1)
        return filteredRefs[0];
    return (inst) => {
        for (const ref of filteredRefs) {
            if (typeof ref === 'function') {
                ref(inst);
            }
            else if (isMutableRefObject(ref)) {
                ref.current = inst;
            }
        }
    };
};
//# sourceMappingURL=index.js.map